export const API_KEY = {
    BASE_LOCAL:`https://localhost:6001/master/api/`,
    BASE_DEV:`https://clementine-dev-master.azurewebsites.net/master/api/`,
    BASE_TEST:`https://clementine-test-master.azurewebsites.net/master/api/`,
    BASE_PROD:`https://as-prod-clementine-master.azurewebsites.net/master/api/`,
    POST_REFRESH:(baseURL:string)=>`${baseURL}v1/account/refresh`,
}